import React from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import SubmenuSuppliers from '../submenu/SubmenuSuppliers'
import SuppliersOptions from './options/SuppliersOptions'
import SupplierList from './SupplierList'
import SuppliersFilters from './filters/SuppliersFilters'

const Suppliers = () => {
  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuSuppliers />
		</MyBlock>
		{/* <MyBlock>
			<h2>Партії товарів (QR-коди) з замовлення KeyCRM</h2>
		</MyBlock> */}
		<MyBlockHeader
            header={'Постачальники'}
            options={
                <SuppliersOptions />
            }
        />
		<MyBlock>
            <SuppliersFilters />
        </MyBlock>
		<MyBlock>
			<SupplierList />
		</MyBlock>
    </LayoutMain>
  )
}

export default Suppliers